import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { AppConstant } from '../config/app.constant';
import { APIs } from 'src/app/config/api.constant';
import { environment } from 'src/environments/environment';
import { SidenavService } from 'src/app/services/sidenav.service';

@Injectable({
  providedIn: 'root'
})
export class RolebasedactionService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private sideNavService: SidenavService,
  ) { }



  checkUserRolePermissionExits(moduleName) {

    const permissionData = JSON.parse(localStorage.getItem('claAdminPermissions'));

    console.log(moduleName);
    console.log(permissionData.modulePermission);
    console.log(this.sideNavService.ParkiteNav);

    const hasPermission = permissionData.modulePermission.includes(moduleName);
    return hasPermission;

  }
}
